export default "__VITE_ASSET__DvNqbdv9__"